/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from "react";
import "./Reports.css";
import DateFilter from "../../components/DateFilter/DateFilter";
import pdfImage from "../../assets/icon_pdf.png";
import ErrorContainer from "../../components/ErrorContainer/ErrorContainer";
import LoadingContainer from "../../components/LoadingContainer/LoadingContainer";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { fetchReports } from "../../app/slices/reportsSlice";
import { dateFormat, oracleDateFormat } from "../../app/utils";

const Reports = () => {
  const {
    data: reportsList,
    status: statusReports,
    error: errorReports,
  } = useSelector(({ reports }) => reports.get);

  const [formValues, setFormValues] = useState({
    fromDate: moment().subtract(1, "years").format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
    status: "A",
  });

  const dispatch = useDispatch();

  //use effects
  useEffect(() => {
    handleSubmit();
  }, []);

  //methods
  const handleSubmit = () => {
    dispatch(
      fetchReports({
        start_date: formValues?.fromDate
          ? moment(formValues?.fromDate).format(oracleDateFormat)
          : null,
        end_date: formValues?.toDate
          ? moment(formValues?.toDate).format(oracleDateFormat)
          : null,
        status: formValues?.status,
      })
    );
  };
  //builders

  const BuildListItem = ({ report }) => {
    return (
      <a
        href={`${process.env.REACT_APP_SERVER_URL}/uploads/reports/${report?.attachment}`}
        target="_blank"
      >
        <div className="report-item">
          <div className="flex-row justify-content-center mb-5">
            <img src={pdfImage} alt="PDF" />
          </div>
          <h3>{report?.title}</h3>
          <small>Description:</small>
          <p>
            {report?.description?.length > 100
              ? report?.description?.substring(0, 99)
              : report?.description}
          </p>
          <small>Published On:</small>
          <p>{moment(report?.published_date).format(dateFormat)}</p>
        </div>
      </a>
    );
  };

  return (
    <div className="reports app-padding">
      <DateFilter
        formValues={formValues}
        setFormValues={setFormValues}
        handleSubmit={handleSubmit}
      />
      <section className="mb-30">
        <div className="flex-row flex-wrap">
          {reportsList?.map((item) => (
            <BuildListItem report={item} />
          ))}
        </div>

        {statusReports === "loading" && (
          <LoadingContainer message={"Loading please wait..."} />
        )}

        {errorReports && statusReports !== "loading" && (
          <ErrorContainer
            message={errorReports?.message}
            onReload={() => {
              handleSubmit();
            }}
          />
        )}
      </section>
    </div>
  );
};

export default Reports;
